module.exports = __webpack_public_path__ + "silver.svg?2d893da98a9825b44ad784ed8cc0b0aa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/silver.svg
// module id = 108
// module chunks = 0